<template>
  <div>
    <div class="ad">
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="原密码" prop="old_password">
          <el-input
            type="password"
            v-model.number="ruleForm.old_password"
            autocomplete="off"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="new_password">
          <el-input type="password" v-model="ruleForm.new_password" autocomplete="off" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirm_password">
          <el-input type="password" v-model="ruleForm.confirm_password" autocomplete="off" show-password></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm(ruleForm)" class="sub">提交</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("原密码不能为空"));
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.confirm_password !== "") {
          this.$refs.ruleForm.validateField("confirm_password");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.new_password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        old_password: "",
        new_password: "",
        confirm_password: ""
      },
      rules: {
        old_password: [{ validator: checkAge, trigger: "blur" }],
        new_password: [{ validator: validatePass, trigger: "blur" }],
        confirm_password: [{ validator: validatePass2, trigger: "blur" }]
      }
    };
  },
  methods: {
    async submitForm(formName) {
      // $(".sub").attr("disabled", "true");
      var old_password = this.$md5(this.ruleForm.old_password+'')
      var new_password = this.$md5(this.ruleForm.new_password+'')
      var confirm_password = this.$md5(this.ruleForm.confirm_password+'')
      var dt  = await this.$axios.post("/api/modification", {
        'old_password': old_password,
        'new_password': new_password,
        'confirm_password': confirm_password
      });
      dt.data = JSON.parse(dt.data)
      if(dt.status == 200){
        if(dt.data.code == 3){
          this.$message({
            type: 'info',
            message: dt.data.msg
          });
          this.$router.push('/admin/')
          return;
        }else if(dt.data.code !== 0){
          this.$message({
              type: 'info',
              message: dt.data.msg
            });
          return;
        }else{
          this.$message({
          message: '修改成功，请重新登陆！',
          type: 'success'
        });
        }
      }else{
        alert(dt.statusText)
        return;
      }
      // $(".sub").removeAttr("disabled");
      window.sessionStorage.removeItem("token");
      this.$router.push("/admin/");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/admin/changepwd.vue